import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Eye } from 'lucide-react';
import Reveal from '@/components/site/Reveal';
import SectionHeading from '@/components/site/SectionHeading';

export default function About() {
  return (
    <section id="about" data-testid="home-about" className="py-20 md:py-28 bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <div className="relative overflow-hidden rounded-2xl">
                <img
                  src="https://images.unsplash.com/photo-1576731753569-3e93a228048c?auto=format&fit=crop&w=2000&q=80"
                  alt="Premium commercial building"
                  className="h-[420px] w-full object-cover md:h-[520px]"
                />
                <div className="absolute bottom-5 left-5 right-5 rounded-xl border border-white/15 bg-[#144726]/85 p-5 backdrop-blur">
                  <p className="text-xs uppercase tracking-[0.2em] text-[#C6A35B]">Founded with discipline</p>
                  <p className="mt-2 font-display text-2xl font-semibold text-white">Helping owners build value beyond leasing.</p>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={120}>
              <SectionHeading
                kicker="About Cespedis"
                title="Building Value Beyond Leasing."
                subtitle="Cespedis is a specialized commercial real estate and property management firm focused on helping landlords, developers, and investors achieve superior returns from their commercial assets."
              />
              <p className="mt-5 text-slate-600 leading-relaxed">
                From tenant sourcing and lease negotiations to day-to-day property operations, our team delivers end-to-end solutions designed to maximize occupancy, optimize revenue, and protect long-term asset value.
              </p>

              <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
                  <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#C6A35B]/15 text-[#144726]"><Target className="h-5 w-5" /></div>
                  <h3 className="mt-4 font-semibold text-[#144726]">Our Mission</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">Deliver professional real estate solutions through integrity, market expertise, and long-term client partnerships.</p>
                </div>
                <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
                  <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#C6A35B]/15 text-[#144726]"><Eye className="h-5 w-5" /></div>
                  <h3 className="mt-4 font-semibold text-[#144726]">Our Vision</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">Become India’s most trusted commercial leasing and property management partner.</p>
                </div>
              </div>

              <Link to="/about" className="mt-8 inline-flex items-center gap-2 font-semibold text-[#144726] hover:text-[#C6A35B] transition-colors link-gold">
                Read our story <ArrowRight className="h-4 w-4" />
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
